import { INSTANCE_SETTINGS_UPDATE, INSTANCE_SETTINGS_UPDATE_IN_PLACE } from 'client/redux/instance/constants';
import * as actionCreators from 'client/redux/instance/actionCreators';

export const instanceSettingsUpdate = (connectorType, id, newSettings) => dispatch => {
  return dispatch(actionCreators.instanceSettingsUpdate(INSTANCE_SETTINGS_UPDATE, connectorType, id, newSettings));
};

export const instanceSettingsUpdateInPlace = (instanceId, settings) => dispatch => dispatch(actionCreators.instanceSettingsUpdateInPlace(INSTANCE_SETTINGS_UPDATE_IN_PLACE, instanceId, settings));
